module.exports = __webpack_public_path__ + "static/media/video-tm6.e0658585.mp4";